import exercisesViewsManager from '../../../common/exercisesViewsManager'
import useExerciseStore from '../../zustand/exerciseState'

export function useGetAttemptsText() {
	const attempts = useExerciseStore((store) => store.attempts)

	return exercisesViewsManager.getAttemptsText(attempts)
}
